import { useCallback, useState } from "react";
import useDebounceValue from "./useDebounceValue";

// Hook untuk handle suggestion
const useSuggestion = ({ name, module, onDropdownVisibleCallback }) => {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");

  const containerId = `suggestion-${module}-${name}`;
  const popUpClassName = `suggestion-${module}-popup-${name}`;

  const debouncedSearch = useDebounceValue(search, 400);

  const searchHandler = useCallback((v) => setSearch(v), []);

  const dropdownVisibleChangeHandler = useCallback(
    (value) => {
      if (!value) {
        setSearch("");
      }
      setOpen(value);
      if (typeof onDropdownVisibleCallback === "function") {
        onDropdownVisibleCallback(value);
      }
    },
    [onDropdownVisibleCallback]
  );

  const getPopupContainer = useCallback(
    () => document.getElementById(containerId),
    [containerId]
  );

  const popUpScrollHandler = useCallback(
    (e, { hasNextPage, isFetchingNextPage, fetchNextPage }) => {
      const { target } = e;
      if (
        hasNextPage &&
        !isFetchingNextPage &&
        Math.ceil(target.scrollTop + target.offsetHeight) >= target.scrollHeight
      ) {
        fetchNextPage();
        if (typeof target.scrollTo === "function") {
          target.scrollTo(0, target.scrollHeight);
        }
      }
    },
    []
  );

  return {
    open,
    setOpen,
    containerId,
    popUpClassName,
    debouncedSearch,
    onDropdownVisible: dropdownVisibleChangeHandler,
    getPopupContainer,
    onSearch: searchHandler,
    onPopUpScroll: popUpScrollHandler,
  };
};

export default useSuggestion;
